import * as React from 'react';

import { cn } from '../../lib/utils';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './tabs-simple';

type ConnectedTabItem = {
  value: string;
  label: React.ReactNode;
};

type ConnectedTabsProps = {
  value: string;
  onValueChange: (value: string) => void;
  items: ConnectedTabItem[];
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  listClassName?: string;
  triggerClassName?: string;
};

function ConnectedTabs({ value, onValueChange, items, children, className, headerClassName, listClassName, triggerClassName }: ConnectedTabsProps) {
  return (
    <Tabs value={value} onValueChange={onValueChange} className={className}>
      <div className={cn('mb-0 flex items-end border-b border-border', headerClassName)}>
        <TabsList className={cn('inline-flex gap-0 rounded-none border-0 bg-transparent p-0 shadow-none', listClassName)}>
          {items.map((item) => {
            const isActive = item.value === value;

            return (
              <TabsTrigger
                key={item.value}
                value={item.value}
                className={cn(
                  'rounded-t-md rounded-b-none border border-transparent border-b-0 px-4 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? '-mb-px border-border bg-background text-primary shadow-none'
                    : 'bg-muted/40 text-muted-foreground hover:bg-muted/60 hover:text-foreground',
                  triggerClassName
                )}
              >
                {item.label}
              </TabsTrigger>
            );
          })}
        </TabsList>
      </div>

      {children}
    </Tabs>
  );
}

type ConnectedTabsContentProps = React.ComponentProps<typeof TabsContent>;

function ConnectedTabsContent({ className, ...props }: ConnectedTabsContentProps) {
  return <TabsContent className={cn('mt-0 rounded-b-md border border-border border-t-0 p-4', className)} {...props} />;
}

export { ConnectedTabs, ConnectedTabsContent };
